var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshIndigoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 0C1.55228 0 2 0.447715 2 1V3.10125C3.27009 1.80489 5.04052 1 7 1C10.0494 1 12.641 2.94932 13.6014 5.66675C13.7855 6.18747 13.5126 6.75879 12.9918 6.94284C12.4711 7.12689 11.8998 6.85396 11.7157 6.33325C11.0289 4.38991 9.17547 3 7 3C5.36507 3 3.91204 3.78502 2.99935 5H6C6.55228 5 7 5.44772 7 6C7 6.55228 6.55228 7 6 7H1C0.447715 7 0 6.55228 0 6V1C0 0.447715 0.447715 0 1 0ZM1.00817 9.05716C1.52888 8.87311 2.1002 9.14604 2.28425 9.66675C2.97112 11.6101 4.82453 13 7 13C8.63493 13 10.088 12.215 11.0006 11L8 11C7.44772 11 7 10.5523 7 10C7 9.44771 7.44772 9 8 9H13C13.2652 9 13.5196 9.10536 13.7071 9.29289C13.8946 9.48043 14 9.73478 14 10V15C14 15.5523 13.5523 16 13 16C12.4477 16 12 15.5523 12 15V12.8987C10.7299 14.1951 8.95948 15 7 15C3.95059 15 1.35905 13.0507 0.398572 10.3332C0.214525 9.81253 0.487449 9.24121 1.00817 9.05716Z",
    fill: "#6366F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIndigoIcon);
export default __webpack_public_path__ + "static/media/refreshIndigoIcon.13e1b84469275c047038313d0535ce7b.svg";
export { ForwardRef as ReactComponent };